module.exports = __webpack_public_path__ + "img/marker-icon-2x.680f69f.png";